"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = require("./Link.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ChevronRightIcon = function ChevronRightIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }));
};

ChevronRightIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var ArrowGrow = function ArrowGrow(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M1 8.267h16M16.733 8.552lNaN NaN",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeWidth: "2"
  }));
};

ArrowGrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "16"
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M1 8.267h16m-6-6l5.836 5.569m-.103.716l-5.569 5.835",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    strokeWidth: "2"
  }));
};

ArrowRightIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "16",
  viewBox: "0 0 19 16"
};

var Link = function Link(props) {
  var children = props.children,
      to = props.to,
      textColor = props.textColor,
      margin = props.margin,
      a11yTitle = props.a11yTitle,
      icon = props.icon,
      primary = props.primary,
      secondary = props.secondary,
      tertiary = props.tertiary;
  var linkComponentInner = children;
  var linkComponent = to ? _react.default.createElement(_Link.StyledRouterLink, _extends({
    "aria-label": a11yTitle
  }, props), linkComponentInner) : _react.default.createElement(_Link.StyledLink, _extends({
    "aria-label": a11yTitle
  }, props), linkComponentInner);
  return primary || secondary || tertiary ? linkComponent : icon === 'RightArrow' ? _react.default.createElement(_Link.StyledLinkContainerArrow, {
    textColor: textColor,
    margin: margin
  }, linkComponent, _react.default.createElement(ArrowGrow, null), _react.default.createElement(ArrowRightIcon, null)) : _react.default.createElement(_Link.StyledLinkContainer, {
    textColor: textColor,
    margin: margin
  }, linkComponent, _react.default.createElement(ChevronRightIcon, null));
};
/**
 * Definition of default values for component props
 */


exports.Link = Link;
Link.defaultProps = {
  children: [],
  a11yTitle: '',
  textColor: '',
  underlineColor: '',
  hoverColor: '',
  margin: '',
  icon: 'ChevronRight',
  primary: false,
  secondary: false,
  tertiary: false,
  isHover: false,
  to: undefined
};
Link.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  a11yTitle: _propTypes.default.string,
  textColor: _propTypes.default.string,
  underlineColor: _propTypes.default.string,
  hoverColor: _propTypes.default.string,
  margin: _propTypes.default.string,
  icon: _propTypes.default.oneOf(['ChevronRight', 'RightArrow', undefined]),
  primary: _propTypes.default.bool,
  secondary: _propTypes.default.bool,
  tertiary: _propTypes.default.bool,
  isHover: _propTypes.default.bool,
  to: _propTypes.default.string
};